
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.75 4H4.25a.25.25 0 0 0-.25.25v2.5a.25.25 0 0 0 .25.25H13v1.25a.25.25 0 0 0 .25.25h2v7.037a8.462 8.462 0 0 0-7.744 8.149A1.754 1.754 0 0 0 9.259 25.5h3.388a3.498 3.498 0 0 0 6.706 0h3.388a1.755 1.755 0 0 0 1.753-1.814 8.462 8.462 0 0 0-7.744-8.15V8.5h2a.25.25 0 0 0 .25-.25V7h8.75a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25Zm-5.009 20H9.26a.254.254 0 0 1-.254-.26 7 7 0 0 1 13.99 0 .255.255 0 0 1-.155.24.254.254 0 0 1-.099.02ZM16 26.5a1.991 1.991 0 0 1-1.723-1h3.446a1.991 1.991 0 0 1-1.723 1Z"}})])
          )
        }
      }
    